{
  "learn.articles.branching": "Branching (TBA)",
  "learn.articles.customProps": "Custom properties",
  "learn.articles.dsReference": "Design System reference",
  "learn.articles.elementApi": "The element API",
  "learn.articles.firstComponents": "Creating your first components",
  "learn.articles.functions": "Functions reference",
  "learn.articles.howToCode": "How to code",
  "learn.articles.importExport": "Import & export (TBA)",
  "learn.articles.intro": "Let's run through a few tutorials...",
  "learn.articles.intro2": "Intro",
  "learn.articles.publishing": "Publishing & domains (TBA)",
  "learn.articles.routing": "Routing and pages",
  "learn.articles.versioning": "Versioning (TBA)",
  "learn.checklist.addColor": "Add a color",
  "learn.checklist.createComponent": "Create a component",
  "learn.checklist.createPage": "Create a main page",
  "learn.checklist.importLibrary": "Import from Library",
  "learn.checklist.noComponent.message": "Please add a component first",
  "learn.checklist.noComponent.title": "No component to reuse",
  "learn.checklist.noPage.message": "Please add a page first",
  "learn.checklist.noPage.title": "No page to open",
  "learn.checklist.openPage": "Open your page",
  "learn.checklist.publish": "Publish",
  "learn.checklist.reuseComponent": "Reuse a component",
  "learn.checklist.title": "Quick checklist",
  "learn.checklist.uploadLogo": "Upload a logo",
  "learn.coach.canvas.descr": "Dive into your interactive canvas. Pan, zoom, and explore freely as you build.",
  "learn.coach.canvas.title": "Enjoy the canvas",
  "learn.coach.canvasAlt.descr": "You are about to experience the canvas experience. Pan and zoom around as you build.",
  "learn.coach.edit.descr": "Double-click to open any element. Right-click for contextual actions. Topbar for navigation.",
  "learn.coach.edit.title": "Edit your app",
  "learn.coach.previous": "Previous",
  "learn.coach.realtime.descr": "You get a free domain for instant sharing, previews, and seamless cross-device testing.",
  "learn.coach.realtime.title": "Realtime experience",
  "learn.coach.zoom.title": "Move around and zoom canvas",
  "learn.codeExample.openInDashboard": "Open in dashboard",
  "learn.codeExample.title": "Code Example",
  "learn.docs.title": "Docs and articles",
  "learn.drag.step1": "1. Add this component first",
  "learn.drag.step2": "2. Add this next",
  "learn.drag.step3": "3. Now, lets add the page",
  "learn.example.accordion.descr": "Expand and collapse sections.",
  "learn.example.accordion.title": "Accordion",
  "learn.example.clock.descr": "Auto update every second.",
  "learn.example.clock.title": "Clock",
  "learn.example.conditional.descr": "Show or hide based on state.",
  "learn.example.conditional.title": "Conditional Rendering",
  "learn.example.counter.descr": "Increment and decrement a number.",
  "learn.example.counter.title": "Counter",
  "learn.example.dynamicList.descr": "Add and remove list items dynamically.",
  "learn.example.dynamicList.title": "Dynamic List",
  "learn.example.fetch.descr": "Fetch data and update state.",
  "learn.example.fetch.title": "Async Fetch",
  "learn.example.formInput.descr": "Capture input and reflect in UI.",
  "learn.example.formInput.title": "Form Input",
  "learn.example.progress.descr": "Fill dynamically with state.",
  "learn.example.progress.title": "Progress Bar",
  "learn.example.tabs.descr": "Switch content via active state.",
  "learn.example.tabs.title": "Tabs",
  "learn.example.toggling.descr": "Switch a boolean and update UI.",
  "learn.example.toggling.title": "Toggling State",
  "learn.examples.less": "Less examples",
  "learn.examples.more": "More examples",
  "learn.examples.open": "Open examples",
  "learn.examples.title": "Quick examples",
  "learn.gettingStarted.hide": "Hide",
  "learn.gettingStarted.title": "Getting Started",
  "learn.gifSlider.next": "Next",
  "learn.gifSlider.okay": "Okay",
  "learn.install.addScript": "Add this script to the top of your HTML:",
  "learn.install.chromeExt": "Optionally you can install the Chrome extension to have realtime preview of your Symbols:",
  "learn.install.docsPage": "Documentations page",
  "learn.install.domain": "Domain",
  "learn.install.extDescr": "Extension is required to gain access to website content",
  "learn.install.extTitle": "Install Chrome extension to allow inspecting",
  "learn.install.footer": "Learn more on how to get started at ",
  "learn.install.install": "Install",
  "learn.install.listenChanges": "Listening changes:",
  "learn.install.oneTimeFetch": "One-time fetch:",
  "learn.install.subtitle": "The short block to get your Symbols integrated:",
  "learn.install.syncStep": "3. Run CLI tool to synchronize:",
  "learn.install.title": "Install Symbols",
  "learn.intro.chatAi": "Chat with AI",
  "learn.intro.continue": "Let's continue your journey using Symbols",
  "learn.intro.dismiss": "Dismiss onboarding",
  "learn.intro.documentation": "Documentation",
  "learn.intro.greeting": "Hi {name} 👋",
  "learn.intro.howToExport": "How to export",
  "learn.intro.libraryComponents": "Library components",
  "learn.intro.moreExamples": "More examples",
  "learn.intro.moreTutorials": "More tutorials",
  "learn.intro.myCode": "My code",
  "learn.intro.myContent": "My content",
  "learn.intro.support": "Support & Resources",
  "learn.intro.symbols": "Intro to Symbols",
  "learn.intro.welcome": "Welcome to your Symbols canvas! This quick guide will walk you through the basics of your workspace.",
  "learn.libraries.less": "Less libraries",
  "learn.libraries.more": "More libraries",
  "learn.libraries.resources": "{amount} resources",
  "learn.libraries.title": "Open source libraries",
  "learn.menu.contribution": "Contribution",
  "learn.menu.onboarding": "Onboarding",
  "learn.menu.properties": "Properties",
  "learn.tutorial.symbolsCodeExplained.descr": "Symbols unifies HTML, CSS, and JavaScript into a single JavaScript object, giving you full control over structure, style, and behavior with elegant, expressive code.",
  "learn.tutorial.symbolsCodeExplained.title": "Enjoy coding!",
  "learn.tutorials.title": "Video Playlist",
  "learn.video.calculator.descr": "Semi-advanced tutorial to show more functionalities",
  "learn.video.calculator.title": "Calculator Tutorial",
  "learn.video.codeEditor.descr": "Changing components and seeing code editor",
  "learn.video.codeEditor.title": "Code editor",
  "learn.video.colors.descr": "How to use colors, shades and variables",
  "learn.video.colors.title": "Using Colors",
  "learn.video.components.descr": "Learn how to create components and use properties",
  "learn.video.components.title": "Building components",
  "learn.video.files.descr": "How to upload and use files",
  "learn.video.files.title": "Using Files",
  "learn.video.gettingStarted.descr": "Getting started with basic landing page",
  "learn.video.gettingStarted.title": "Getting started",
  "learn.video.icons.descr": "How to upload, insert and use icons",
  "learn.video.icons.title": "Using Icons",
  "learn.video.less": "Less videos",
  "learn.video.more": "More videos",
  "learn.video.navigation.descr": "Navigating around Symbols",
  "learn.video.navigation.title": "Navigation",
  "learn.video.pages.descr": "Learn how to create page and relevant properties",
  "learn.video.pages.title": "Building pages",
  "learn.video.spacing.descr": "How to use spacing and variables",
  "learn.video.spacing.title": "Using Spacing",
  "learn.video.symbolsLibrary.descr": "Build using Symbols library",
  "learn.video.symbolsLibrary.title": "Symbols library",
  "learn.video.whatIsSymbols.descr": "What and how you can use Symbols",
  "learn.video.whatIsSymbols.title": "What is Symbols",
  "learn.videoRow.calculator": "Semi Advanced Tutorial Calculator",
  "learn.videoRow.codeEditor": "Changing components and seeing code editor",
  "learn.videoRow.colors": "How to use color",
  "learn.videoRow.components": "Building components",
  "learn.videoRow.files": "How to use files",
  "learn.videoRow.gettingStarted": "Getting started with basic landing page",
  "learn.videoRow.icons": "How to use icon",
  "learn.videoRow.navigation": "Navigating around Symbols",
  "learn.videoRow.pages": "Building pages",
  "learn.videoRow.spacing": "How to use spacing",
  "learn.videoRow.symbolsLibrary": "Build using Symbols library",
  "learn.videoRow.whatIsSymbols": "What is Symbols"
}
